export const getNextPageParam = (prevData: { nextPage: number | undefined | null }) => {
  if (prevData.nextPage === null) return undefined;
  return prevData.nextPage;
};
